module.exports = __webpack_public_path__ + "static/img/5.ccb6ab3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/zh/5.png
// module id = SR33
// module chunks = 0